import React from "react";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import mani from "../media/software/mani.png";
import plogger from "../media/software/plogger.png";
import lang4j from "../media/software/lang4j.png";
import musicblender from "../media/software/musicblender.png";
import thegamemasterscreen from "../media/software/thegamemasterscreen.png";
import potsandplots from "../media/software/potsandplots.png";
import rolltableroller from "../media/software/rolltableroller.png";
import comunatee from "../media/software/comunatee.png";

const Software = () => {
  const getSortKey = (yearString) => {
    if (!yearString) return [0, 0];
    // Extract both start and end year for sorting
    if (yearString.includes("-")) {
      const parts = yearString.split("-");
      const startYear = parseInt(parts[0]) || 0;
      if (parts[1] === "ongoing") {
        return [9999, startYear]; // ongoing is most recent, then sort by start date
      }
      const endYear = parseInt(parts[1]) || 0;
      return [endYear, startYear]; // use end year as primary sort, start year as tiebreaker
    }
    const year = parseInt(yearString) || 0;
    return [year, year]; // single year - both same
  };

  const projects = [
    {
      id: 1,
      title: "Máni Language",
      image: mani,
      status: "abandoned",
      statusColor: "#FF5733",
      description:
        "Majority contributor to a community project to build a new programming language, designed to be easy to learn and to teach programming concepts. Personally built the Máni 'compiler'.",
      technologies: ["Java", "Parser", "Compiler", "New Language"],
      year: "2019",
      link: "https://github.com/mani-language/Mani",
    },
    {
      id: 2,
      title: "Tabletop Buddy",
      image: null,
      status: "active/open development",
      statusColor: "orange",
      description:
        "Web tool for creating and managing character sheets for TTRPGs, particularly 'Daggerheart'. Provides tools for session management, random name generators, and statblocks.",
      technologies: ["React", "TTRPGs", "Daggerheart"],
      year: "2024",
      link: "https://github.com/JamesIAm/ttBuddy",
    },
    {
      id: 3,
      title: "PixoleLogger",
      image: plogger,
      status: "built",
      statusColor: "green",
      description: "Lightweight logging tool for Java with minimal overhead.",
      technologies: ["Java", "Logging"],
      year: "2019",
      link: "https://github.com/Kalekdan/Pixole-Logger",
    },
    {
      id: 4,
      title: "lang4j",
      image: lang4j,
      status: "built",
      statusColor: "green",
      description:
        "Lightweight Java tool for adding language translations to applications.",
      technologies: ["Java"],
      year: "2019",
      link: "https://github.com/Kalekdan/lang4j",
    },
    {
      id: 5,
      title: "Music Blender",
      image: musicblender,
      status: "active development",
      statusColor: "orange",
      description:
        "Web app to play music from YouTube overlayed in various scenes which can be switched between and individually controlled.",
      technologies: ["React", "YouTube API", "TTRPGs"],
      year: "2022-ongoing",
      link: "https://github.com/Kalekdan/musicblender",
      liveApp: "https://musicblender.co.uk",
    },
    {
      id: 6,
      title: "Letterboxd Tools",
      image: null,
      status: "active development",
      statusColor: "orange",
      description:
        "Set of scripts that scrape Letterboxd user data to find films common between watchlists.",
      technologies: ["Python", "Web Scraping"],
      year: "2022",
      link: "https://github.com/Kalekdan/letterboxd-tools",
    },
    {
      id: 7,
      title: "Simple Wiki",
      image: null,
      status: "built",
      statusColor: "green",
      description:
        "Chrome extension to switch between Wikipedia and its 'Simple Wiki' counterpart.",
      technologies: ["JavaScript", "Chrome Extension"],
      year: "2020",
      link: "https://github.com/Kalekdan/SimpleWiki",
    },
    {
      id: 8,
      title: "Tradeup Buddy",
      image: null,
      status: "built",
      statusColor: "green",
      description:
        "Tool to find CS:GO skin tradeups with the highest probability for profitability.",
      technologies: ["JavaScript", "APIs", "Counter-Strike: Global Offensive"],
      year: "2019",
      link: "https://github.com/Kalekdan/Tradeup-Buddy",
    },
    {
      id: 9,
      title: "The GameMaster Screen",
      image: thegamemasterscreen,
      status: "built",
      statusColor: "green",
      description: "Customizable digital GM screen for tabletop RPGs.",
      technologies: ["React", "TTRPGs"],
      year: "2025",
      link: "https://github.com/Kalekdan/thegamemasterscreen",
      liveApp: "https://thegamemasterscreen.com",
    },
    {
      id: 10,
      title: "Pots and Plots",
      image: potsandplots,
      status: "active development",
      statusColor: "orange",
      description:
        "Web app to help plan and manage your plants, both houseplants, as well as plots in your garden.",
      technologies: ["React", "Spring Boot", "Gardening"],
      year: "2025-ongoing",
      link: "https://github.com/Kalekdan/PotsAndPlots",
    },
    {
      id: 11,
      title: "Roll Table Roller",
      image: rolltableroller,
      status: "built",
      statusColor: "green",
      description:
        "A simple web app to create and roll on custom roll tables for tabletop RPGs.",
      technologies: ["Python", "TTRPGs"],
      year: "2024",
      link: null
    },
    {
      id: 12,
      title: "Jot (Joe-bot)",
      image: null,
      status: "active development",
      statusColor: "orange",
      description: "AI-powered personal assistant bot to control my house, manage my calendar, and just be generally helpful.",
      technologies: ["Python", "AI", "Home Automation"],
      year: "2025-ongoing",
      link: "https://github.com/Kalekdan/Jot",
    },
    {
      id: 13,
      title: "Comunatee",
      image: comunatee,
      status: "abandoned",
      statusColor: "red",
      description: "A reddit alternative, focused on community driven content curation and discovery.",
      technologies: ["React", "Spring Boot", "Communities"],
      link: "",
      year: "2025",
    }
  ].sort((a, b) => {
    const keyA = getSortKey(a.year);
    const keyB = getSortKey(b.year);
    // Compare primary sort keys (end year), then secondary (start year)
    if (keyB[0] !== keyA[0]) {
      return keyB[0] - keyA[0]; // descending order
    }
    return keyB[1] - keyA[1]; // descending order for start year tiebreaker
  });

  return (
    <>
      <div className="title">
        <h2 className="heading">software & tools.</h2>
        <p className="section-subtitle">Projects that solve problems & spark ideas</p>
      </div>
            <div className="software-intro">
        <p>
          I went to university to study computer science and have been coding since I was pretty young, first learning making games on the Raspberry Pi. Over the past <i>many</i> years, I've build a load of different things, some of which I've actually finished! Below are just a selection, and some are pretty old, so go easy on me!
        </p>
        <Button
          href="https://github.com/Kalekdan"
          target="_blank"
          rel="noreferrer"
          variant="contained"
          sx={{
            backgroundColor: "var(--primary-color2)",
            color: "white",
            mt: 2,
            "&:hover": {
              backgroundColor: "var(--primary-color3)",
            },
          }}
        >
          Follow me on GitHub
        </Button>
      </div>
      <div className="software-content">
        {projects.map((project) => (
          <div key={project.id} className="software-element">
            <div className="project-header">
              <h2>{project.title}</h2>
              <Chip
                className="software-status-chip"
                label={project.status}
                sx={{ bgcolor: project.statusColor, color: "white" }}
              />
            </div>

            {project.image && (
              <img
                alt={project.title}
                src={project.image}
                loading="lazy"
                className="project-image"
              />
            )}

            <p className="project-description">{project.description}</p>

            <div className="project-tech">
              {project.technologies.map((tech) => (
                <span key={tech} className="tech-tag">
                  {tech}
                </span>
              ))}
            </div>

            <div className="project-footer">
              <span className="project-year">{project.year}</span>
              <div style={{ display: "flex", gap: "8px" }}>
                {project.liveApp && (
                  <Button
                    href={project.liveApp}
                    target="_blank"
                    rel="noreferrer"
                    variant="outlined"
                    size="small"
                    sx={{
                      borderColor: "var(--primary-color2)",
                      color: "var(--primary-color2)",
                      "&:hover": {
                        backgroundColor: "rgba(191, 99, 48, 0.1)",
                        borderColor: "var(--primary-color3)",
                      },
                    }}
                  >
                    View App 🌐
                  </Button>
                )}
                <Button
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: "var(--primary-color2)",
                    color: "var(--primary-color2)",
                    "&:hover": {
                      backgroundColor: "rgba(191, 99, 48, 0.1)",
                      borderColor: "var(--primary-color3)",
                    },
                  }}
                >
                  Explore Code 🔗
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Software;
